module.exports = __webpack_public_path__ + "static/media/Avenir-Roman.016811bb.woff2";